import { render, staticRenderFns } from "./BuyNftModal.vue?vue&type=template&id=0adf9caa&scoped=true&"
import script from "./BuyNftModal.vue?vue&type=script&lang=js&"
export * from "./BuyNftModal.vue?vue&type=script&lang=js&"
import style0 from "./BuyNftModal.vue?vue&type=style&index=0&id=0adf9caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adf9caa",
  null
  
)

export default component.exports